<div class="grid">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoListar">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoListar">
			<!-- <div class="formgroup">
				<div class="p-fluid p-formgrid grid">
					<div class="field col-12 md:col-2">
						<button pButton pRipple routerLink="/apps/" label="Novo" icon="pi pi-plus"
							class="p-button-outlined sm:w-9rem"></button>
					</div>
				</div>
			</div> -->
			<div class="flex justify-content-center" *ngIf="loadingPrincipal">
				<p-progressSpinner></p-progressSpinner>
			</div>
			<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
				<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
			</div>
			<p-table #dt1 [value]="listaContas" dataKey="id" [rows]="10" [loading]="loading" [rowHover]="true"
				[paginator]="true" [globalFilterFields]="['descricao', 'planoContaEmpresa.descricao']"
				responsiveLayout="stack" styleClass=" p-datatable-sm">
				<ng-template pTemplate="caption">
					<div class="flex justify-content-end flex-column sm:flex-row">

						<div class="p-fluid">
							<div class="flex">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscar(dt1, $event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limpar(dt1)"></button>
								</span>
							</div>
						</div>
					</div>
				</ng-template>
				<ng-template pTemplate="header">
					<tr>
						<th pSortableColumn="descricao">
							Descricão
							<p-sortIcon field="descricao">
							</p-sortIcon>
						</th>
						<th pSortableColumn="tipoConta">
							Tipo
							<p-sortIcon field="tipoConta">
							</p-sortIcon>
						</th>
						<th pSortableColumn="saldo">
							Saldo
							<p-sortIcon field="saldo">
							</p-sortIcon>
						</th>
						<th>
							Ações
						</th>

					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-item>
					<tr>

						<td>
							{{item.descricao}}
						</td>
						<td>
							{{item.tipoConta}}
						</td>
						<td>
							{{item.saldo | currency:'BRL'}}
						</td>

						<td>
							<div>
								<button *ngIf="permissaoInserir" pButton pRipple
									pTooltip="Saída" icon="pi pi-sign-out" class="p-button-info"
									(click)="abrirDialogTransferencia(item)">
								</button>
							</div>

						</td>

					</tr>
				</ng-template>
				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="7">Nenhum registro encontrado.</td>
					</tr>
				</ng-template>
				<ng-template pTemplate="loadingbody">
					<tr>
						<td colspan="7">Carregando. Por favor aguarde.</td>
					</tr>
				</ng-template>
			</p-table>
			<p-dialog [(visible)]="exibirDialogTransferencia" [modal]="true"
				[style]="{width: '40rem'}" [breakpoints]="{'960px': '75vw', '640px': '90vw'}" [draggable]="false"
				[resizable]="false" [closable]="true">
				<ng-template pTemplate="header">
					<div class="flex justify-content-start">
						<span class="text-900 text-xl font-bold">
							Transferência - {{contaOrigemSelecionada?.descricao}}
						</span>
					</div>
				</ng-template>
				<div class="flex justify-content-center" *ngIf="exibirSpinnerDialogTransf">
					<p-progressSpinner></p-progressSpinner>
				</div>
				<form #formTransf="ngForm" name="formTransf" *ngIf="!exibirSpinnerDialogTransf">
					<div class="formgroup">
						<div class="p-fluid p-formgrid grid">

							<div class="field col-12 md:col-12">
								<label>Conta Origem</label>
								<label *ngIf="listaTiposPagamentoContaOrigem.length === 1;else dropdownOrigem"
									class="form-control">{{tipoPagamentoContaOrigemSelecionado?.descricao}}</label>
								<ng-template #dropdownOrigem>
									<p-dropdown [options]="listaTiposPagamentoContaOrigem" optionLabel="label"
										optionValue="value"
										emptyFilterMessage="Nenhum registro" name="contaOrigem" ngModel
										#contaOrigem="ngModel" emptyMessage="Nenhum registro"
										[(ngModel)]="tipoPagamentoContaOrigemSelecionado">
									</p-dropdown>

								</ng-template>
							</div>
							<div class="field col-12 md:col-12">
								<label>Conta Destino</label>
								<label *ngIf="listaTiposPagamentoContaDestino.length === 1;else dropdownDestino"
									class="form-control">{{tipoPagamentoContaDestinoSelecionado?.descricao}}</label>
								<ng-template #dropdownDestino>
									<p-dropdown [options]="listaTiposPagamentoContaDestino" optionLabel="label"
										optionValue="value"
										emptyFilterMessage="Nenhum registro" name="contaDestino" ngModel
										#contaDestino="ngModel" emptyMessage="Nenhum registro"
										[(ngModel)]="tipoPagamentoContaDestinoSelecionado">
									</p-dropdown>
								</ng-template>
							</div>
							<div class="field col-12 md:col-6">
								<label>Data</label>
								<p-calendar [readonlyInput]="false" [showIcon]="true" dateFormat="dd/mm/yy"
									[showButtonBar]="true" name="data" ngModel [(ngModel)]="dataTransferencia"
									#data="ngModel" [required]="true" appendTo="body">
								</p-calendar>

							</div>
							<div class="field col-12 md:col-6">
								<label htmlFor="nome">Valor</label>
								<p-inputNumber name="valor" ngModel #valor="ngModel" mode="currency"
									inputId="currency-brazil" currency="BRL" locale="pt-BR" [allowEmpty]="true"
									[required]="true" [(ngModel)]="valorTransferencia">
								</p-inputNumber>
							</div>
						</div>
						<div class="w-full">
							<p-divider></p-divider>
						</div>
						<div class="p-fluid p-formgrid grid justify-content-start">
							<div class="field col-12 md:col-4" style="padding-bottom: 0px; margin-bottom: 0px">
								<button type="button" pButton
									[icon]="loadingTransferir ? 'pi pi-spin pi-spinner':'pi pi-check'"
									label="Transferir" class="p-button-success" (click)="transferir()"
									[disabled]="loadingTransferir">
								</button>
							</div>
						</div>
					</div>
				</form>


			</p-dialog>
		</div>
	</div>
</div>